module.exports = __webpack_public_path__ + "img/eswatini.2e71643.webp";